import React from 'react';
import styles from '../LandingPage.module.css';

const EnterpriseTrustSection = () => {
  const cards = [
    { icon: '✨', title: 'AI-Powered Hiring Ecosystem', desc: 'Accelerate hiring with Prohirey and workforce intelligence — match talent to mission in days, not months.' },
    { icon: '🚀', title: 'Faster GCC Setup', desc: 'Reduce time-to-market with structured GCC BOT frameworks covering entity, hiring, infra and compliance.' },
    { icon: '⚡', title: 'Automation-First Operations', desc: 'Leverage ToxBox AI to optimise workflows, communications and operational productivity across the GCC.' },
    { icon: '🏅', title: 'Enterprise Engineering Excellence', desc: 'Deliver across ServiceNow, Salesforce, Cloud, AI/ML and custom engineering with global delivery standards.' }
  ];

  return (
    <div className={styles.lightSection}>
      <div className={styles.section} style={{ paddingTop: '40px' }}>
        <div className={styles.pillLight}>🔹 Why Provaantech</div>
        <h2 className={styles.sectionTitleLight}>Enterprise trust meets AI-native<br/>execution</h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '24px', marginTop: '40px' }}>
          {cards.map((card, index) => (
            <div key={index} style={{ border: '1px solid #e2e8f0', borderRadius: '20px', padding: '32px 24px', background: '#ffffff', boxShadow: '0 10px 30px rgba(0,0,0,0.02)' }}>
              <div style={{ width: '48px', height: '48px', background: '#3b82f6', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '1.5rem', marginBottom: '24px' }}>
                {card.icon}
              </div>
              <h3 style={{ color: '#0f172a', fontSize: '1.25rem', marginBottom: '12px' }}>{card.title}</h3>
              <p style={{ color: '#475569', lineHeight: 1.6, margin: 0, fontSize: '0.875rem' }}>{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EnterpriseTrustSection;
